{
    "name": "Dark Opal Basil",
    "binomial_name": "Ocimum basilicum",
    "common_names": [
        "Basil",
        "Basilikum"
    ],
    "description": "",
    "sun_requirements": "Full Sun",
    "sowing_method": "",
    "spread": 40,
    "row_spacing": 30,
    "height": 60,
    "growing_degree_days": 650,
    "companions": [],
    "image": "/crops/images/dark-opal-basil.jpg",
    "icon": "/crops/icons/dark-opal-basil.avif"
}